import { apiFetch } from "@/api/client";
import { ENDPOINTS } from "@/api/endpoints";
import { router } from "@/router";
import { setAuth, clearAuth } from "./authStore";

interface LoginResponse {
  token: string;
  must_change_password?: boolean;
}

interface JwtPayload {
  userID: string;
  expiredAt: number;
  role: string;
}

function decodeJwtPayload(token: string): JwtPayload {
  const base64url = token.split(".")[1] ?? "";
  // base64url → base64
  const base64 = base64url.replace(/-/g, "+").replace(/_/g, "/");
  const json = atob(base64);
  return JSON.parse(json) as JwtPayload;
}

function handleLoginResponse(response: LoginResponse): void {
  const payload = decodeJwtPayload(response.token);
  setAuth({
    token: response.token,
    userID: payload.userID,
    expiredAt: payload.expiredAt,
    mustChangePassword: response.must_change_password ?? false,
    role: payload.role ?? "",
  });
}

export async function loginWithPassword(
  email: string,
  password: string,
  deviceId: string,
): Promise<void> {
  const response = await apiFetch<LoginResponse>(ENDPOINTS.auth.login, {
    method: "POST",
    body: JSON.stringify({ email, password, device_id: deviceId }),
  });
  handleLoginResponse(response);
}

export async function loginWithPin(
  email: string,
  pincode: string,
  deviceId: string,
): Promise<void> {
  const response = await apiFetch<LoginResponse>(ENDPOINTS.auth.login, {
    method: "POST",
    body: JSON.stringify({ email, pincode, device_id: deviceId }),
  });
  handleLoginResponse(response);
}

export function saveLastEmail(email: string): void {
  localStorage.setItem("ceasa_last_email", email);
}

export function getLastEmail(): string | null {
  return localStorage.getItem("ceasa_last_email");
}

export function logout(queryClient?: { clear(): void }): void {
  clearAuth();
  queryClient?.clear();
  router.navigate({ to: "/login" });
}
